import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@lmc-env/environment';

@Injectable({
	providedIn: 'root',
})
export class EmployeeService {
	private readonly uri: string = `${environment.DO_URL}/v2`;

	constructor(private readonly http: HttpClient) {}

	// Application CRUD operations
	createEmployee(data: any): Observable<any> {
		return this.http.post(`${this.uri}/employee`, data);
	}

	getEmployees(): Observable<any> {
		return this.http.get(`${this.uri}/employees`);
	}

	getEmployee(id: number): Observable<any> {
		return this.http.get(`${this.uri}/employee/${id}`);
	}

	updateEmployee(data: any): Observable<any> {
		return this.http.put(`${this.uri}/employee/${data.employee_id}`, data);
	}

	resetPassword(data: any): Observable<any> {
		return this.http.put(`${this.uri}/employee_reset_password`, data);
	}
}
